import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "title" }, "鲲鹏登录", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "desc" }, " 千云 scrm 后台管理系统，请用邮箱前缀及密码登录 ", -1)
const _hoisted_5 = { class: "login" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_form = _resolveComponent("a-form")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_icon, {
          name: "logo",
          scale: "4"
        }),
        _hoisted_3
      ]),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_a_form, {
        onSubmit: _ctx.onSubmit,
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { name: "username" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                autocomplete: "autocomplete",
                size: "large",
                value: _ctx.form.username,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.username = $event)),
                placeholder: "邮箱前缀"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_icon, {
                    slot: "prefix",
                    scale: "2",
                    name: "username"
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { name: "password" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                size: "large",
                placeholder: "邮箱密码",
                value: _ctx.form.password,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.password = $event)),
                autocomplete: "autocomplete",
                type: "password"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_icon, {
                    slot: "prefix",
                    scale: "2",
                    name: "password"
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                loading: _ctx.logging,
                style: {"width":"100%","margin-top":"24px"},
                size: "large",
                onClick: _ctx.onSubmit,
                htmlType: "submit",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit", "model", "rules"])
    ])
  ]))
}